import React from 'react';
import formFieldType from '@/forms/helper';
import FormObjectDialog from '@/forms/objects/components/FormObjectDialog';
import { linkFields } from '@/forms/state/state';
import requestFieldComponents from '../helper';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const RequestLinksDialog = ({ theme }) => {
  const state = selectors.useRequestObjectFields();
  const applyChanges = events.useApplyRequestObjects(state.category, { code: state.code });
  const changeItem = events.useUpdateActiveRequestObject();
  const deleteItem = events.useDeleteActiveRequestObject();
  const hide = events.useHideRequestObjects();
  const insertItem = events.useInsertRequestLink();
  const updateProperties = events.useUpdateRequestObjectProperties();
  const updateObjectsProperties = events.useUpdateRequestObjectsProperties();

  return (
    <FormObjectDialog
      activeIndex={state.activeIndex}
      allowAdd={state.allowAdd}
      allowRemove={state.allowRemove}
      canEdit
      category={state.category}
      changeItem={changeItem}
      code={state.code}
      component={(f) => requestFieldComponents[formFieldType(f)]}
      deleteItem={deleteItem}
      entity="request.link"
      field={state.field}
      fields={state.field ? linkFields(state.field) : []}
      hide={hide}
      insertItem={() => insertItem(state)}
      isDirty={state.isDirty}
      isEditing
      item={state.item}
      items={state.items}
      onSave={() => applyChanges(state)}
      saveErrors={state.saveErrors}
      saveStatus={state.saveStatus}
      textField="text"
      theme={theme}
      updateObjectsProperties={updateObjectsProperties}
      updateProperties={updateProperties}
    />
  );
};

export default RequestLinksDialog;
